import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as ModalType } from '@/types/modal';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import Table from '@/components/molecules/section/Table';

const NegoDetails: React.FC<{ modal: Extract<ModalType, { kind: 'NegoDetails' }> }> = ({ modal }) => {
  const { t } = useTranslation();
  const details = modal.item.negoDefectDetails || [];

  const columns: GridColDef[] = [
    {
      field: 'defectName',
      headerName: t('item.compliance.nego_details.defect_name'),
      flex: 1,
    },
    {
      field: 'defectComment',
      headerName: t('item.compliance.nego_details.defect_comment'),
      flex: 2,
    },
  ];

  const rows: GridValidRowModel[] = details.map((detail, index) => ({
    id: index,
    defectName: detail.defectName,
    defectComment: detail.defectComment,
  }));

  return (
    <Dialog
      open={true}
      onClose={modal.onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{t('item.compliance.nego_details.title')}</DialogTitle>
      <DialogContent>
        <Table
          rows={rows}
          columns={columns}
          loading={false}
          table={{
            kind: 'Table',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default NegoDetails;
